import { render, staticRenderFns } from "./customInputAssetInfo.vue?vue&type=template&id=cc129f30&scoped=true&"
import script from "./customInputAssetInfo.vue?vue&type=script&lang=js&"
export * from "./customInputAssetInfo.vue?vue&type=script&lang=js&"
import style0 from "./customInputAssetInfo.vue?vue&type=style&index=0&id=cc129f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc129f30",
  null
  
)

export default component.exports